export default "__VITE_ASSET__8d4f6cf6__"